/* global axios */

import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  createWithCSV(formData) {
    return axios.post(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  validateCSV(formData) {
    return axios.post(`${this.url}/validate_csv`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  trigger(id) {
    return axios.post(`${this.url}/${id}/trigger`);
  }
}

export default new CampaignsAPI();
